module.exports = __webpack_public_path__ + "img/missionaries9_2019_7-7-2021.e19997d1.jpg";